import { render, staticRenderFns } from "./UDNTable.vue?vue&type=template&id=e8c7fd2a&scoped=true"
import script from "./UDNTable.vue?vue&type=script&lang=js"
export * from "./UDNTable.vue?vue&type=script&lang=js"
import style0 from "./UDNTable.vue?vue&type=style&index=0&id=e8c7fd2a&prod&lang=css&scoped=true"
import style1 from "./UDNTable.vue?vue&type=style&index=1&id=e8c7fd2a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c7fd2a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/UDNReport/UDNTable.vue
// module id = 2217
// module chunks = 31